import { createContext, useContext } from 'react';
import * as React from 'react';
import noop from '@sdk/utils/noop';

import { ShiftsBridgeState } from './shiftsBridgeProvider.types';

type Props = {
  children: React.ReactNode;
  bridge: ShiftsBridgeState;
};

export const ShiftsBridgeStateContext = createContext<ShiftsBridgeState>({
  onProjectedSalesImport: noop,
} as ShiftsBridgeState);

export const useShiftsBridge = () => useContext(ShiftsBridgeStateContext);

export const ShiftsBridgeProvider = ({ bridge, children }: Props) => (
  <ShiftsBridgeStateContext.Provider value={bridge}>{children}</ShiftsBridgeStateContext.Provider>
);
